import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Loader from "../components/Loader";
import Pagination from "../components/Pagination";
import gameService from "../services/gameService";

const BetHistory = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [bets, setBets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const res = await gameService.getHistory();
      if (res && res.success) {
        setBets(res.bets || res.history || []);
      }
    } catch (err) {
      toast.error("Failed to load bet history.");
    } finally {
      setLoading(false);
    }
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  const totalPages = Math.ceil(bets.length / itemsPerPage) || 1;
  const currentBets = bets.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar toggleSidebar={toggleSidebar} />

      <div className="d-flex flex-grow-1 position-relative">
        <Sidebar isOpen={sidebarOpen} closeMobileSidebar={closeSidebar} />

        <main className="flex-grow-1 p-3 p-md-4 overflow-auto">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
              <div>
                <h2 className="fw-bold text-dark mb-1">My Bet History</h2>
                <p className="text-secondary mb-0">View all your placed bets and winning claims history.</p>
              </div>
              <button className="btn btn-outline-gold btn-sm fw-bold px-3 py-2" onClick={fetchHistory}>
                <i className="bi bi-arrow-clockwise me-1"></i> Refresh
              </button>
            </div>

            <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
              <div className="card-body p-0">
                {loading ? (
                  <Loader message="Loading bet records..." />
                ) : bets.length === 0 ? (
                  <div className="text-center py-5">
                    <i className="bi bi-journal-text text-muted display-4"></i>
                    <h5 className="fw-bold mt-3 text-secondary">No Bet History</h5>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead>
                        <tr>
                          <th className="ps-4">Bet ID</th>
                          <th>Round No</th>
                          <th>Bet Type</th>
                          <th>Bet Target</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Win Payout</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentBets.map((b) => (
                          <tr key={b.id}>
                            <td className="ps-4 fw-bold">#{b.id}</td>
                            <td className="fw-semibold">Round #{b.round_no || b.round_id}</td>
                            <td><span className="badge bg-secondary">{b.bet_type}</span></td>
                            <td className="fw-bold text-primary">{b.bet_value}</td>
                            <td>🪙 {Number(b.amount || 0).toLocaleString()}</td>
                            <td>
                              <span className={`badge ${b.status === "WIN" ? "bg-success" : b.status === "LOSS" ? "bg-danger" : "bg-warning text-dark"}`}>
                                {b.status}
                              </span>
                            </td>
                            <td className="fw-bold text-success">🪙 {Number(b.win_amount || 0).toLocaleString()}</td>
                            <td className="text-muted small">
                              {b.created_at ? new Date(b.created_at).toLocaleString() : "N/A"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              {!loading && bets.length > 0 && (
                <div className="card-footer border-top p-3">
                  <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default BetHistory;
